import { v4 as uuid } from 'uuid';

import { BadgeTypes } from '../../components/Badge/Badge';
import { ATTACHED_DATA_BLOCK_TYPES } from '../../constants/attachedDataBlockTypes';
import { attachedDataMap } from '../../types/attachedData/attachedDataMap';
import normaliseAttributeKey from '../normaliseAttributeKey';

const NEON_ATTRIBUTE_IDENTIFIER = /CW-NEON_|CW-NEON-(.[^_]*)_/gi;

const badgeRegex = RegExp(`(${Object.values(BadgeTypes).join('|')})`);

export function getAttachedDataFromMap(type: string, data: any) {
  const { type: blockType, label } = attachedDataMap[type] || {};
  const identifier = type.split('_')[0];
  const badgeType = identifier?.match(badgeRegex)?.pop();

  return {
    id: uuid(),
    type: blockType || ATTACHED_DATA_BLOCK_TYPES.DYNAMIC,
    label: normaliseAttributeKey((label || type).replace(NEON_ATTRIBUTE_IDENTIFIER, '')),
    badgeType,
    data,
  };
}

